export default __webpack_public_path__ + "static/media/Boton_5.f4c94354.webp";